//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import parse from 'date-fns/parse'
import format from 'date-fns/format'

import slugify from 'slugify';

export default {

  computed: {
    tours: function() {

      return this.lodash.map( this.unformatted_tours, (tourItem) => {
        let tour = tourItem.tour;

        tour.stops = this.lodash.flatMap( tour.days, (day) => {
          return day.stops;
        } )
        
        return tour;

      })

    },
    
  },
  watch: {

  },
  components: {
    
  },
  data() {
    return { 
      
      unformatted_tours: tours,
      activeTour: null,
      hovering: false,
     
    }
  },
  mounted() {

    console.log('unformatted tours', this.unformatted_tours)
    console.log('tours', this.tours);

    if ( this.tours.length ) {
      this.activeTour = this.tours[0];
    }

  },
  methods: {
    enterTour(tour) {
      this.hovering = true;
      this.activeTour = tour;
    },
    leaveTour(tour) {
      this.hovering = false;
    }
  }
}




// WEBPACK FOOTER //
// ./scripts/components/FeaturedTours.vue